import module from 'contabilidad/catalogosexternos/module.js'
import template from './template.html'

export class CatalogosExternosSucursalEditar {
  nombre
  sucursalId
  inicializar = false
  onClose = undefined

  constructor(CatalogosExternosCatalogosFamilias, CatalogosExternosSucursalCuentasContables, $q) {
    this.CatalogosExternosCatalogosFamiliasService = CatalogosExternosCatalogosFamilias,
      this.CatalogosExternosSucursalCuentasContables = CatalogosExternosSucursalCuentasContables,
      this.$q = $q
  }

  $onInit() {
    this.promise = this.$q.all([
      this.CatalogosExternosCatalogosFamiliasService.get()
        .then((resolve) => {
          this.familias = resolve.data
        }),
      this.CatalogosExternosSucursalCuentasContables.get(this.sucursalId)
      .then(({ data }) => (this.cuentas = data.map((item) => ({
        sucursalId : item.sucursalId,
        familiaId : item.familiaId,
        cuentaContable : item.cuentaContable,
        descripcion : item.descripcion,
        status : item.status,
        deshabilitado : true
      }))))
    ])
    .then(() => {
      if (Object.keys(this.cuentas).length === 0) {
        this.inicializar = true;
      }
    })
  }

  cerrar() {
    this.onClose();
  }

}

module.component('contabilidadCatalogosexternosSucursalesEditar', {
  controller: CatalogosExternosSucursalEditar,
  template,
  bindings: {
    sucursalId: '<',
    nombre: '<',
    onClose: '&'
  },
})


// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/sucursales/editar/component.js